import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import AuthWrapperContainer from '~/containers/AuthWrapper';
import ConfirmationContainer from '~/containers/Confirmation';
import { ShowOnRootProvider } from './context/ShowOnRoot';
import initServices from './services';

// Import pages
import RootPage from './pages/RootPage';
import LoginPage from './pages/login/LoginPage';
import DashboardPage from './pages/dashboard/DashboardPage';
import AlertsPage from './pages/alerts/AlertsListPage';
import AlertDetailPage from './pages/alerts/AlertDetailPage';
import ResidentsPage from './pages/residents/ResidentsListPage';
import ResidentDetailPage from './pages/residents/ResidentDetailPage';
import ResidentEditPage from './pages/residents/ResidentEditPage';
import ResidentCreatePage from './pages/residents/ResidentCreatePage';
import HealthcareProvidersPage from './pages/healthcare-providers/HealthcareProvidersListPage';
import HealthcareProviderEditPage from './pages/healthcare-providers/HealthcareProviderEditPage';
import HealthcareProviderCreatePage from './pages/healthcare-providers/HealthcareProviderCreatePage';
import ConfigurationPage from './pages/configuration/ConfigurationPage';
import AuthorityLevelsPage from './pages/authority-levels/AuthorityLevelsListPage';
import AuthorityLevelDetailPage from './pages/authority-levels/AuthorityLevelDetailPage';
import AuthorityLevelEditPage from './pages/authority-levels/AuthorityLevelEditPage';
import AuthorityLevelCreatePage from './pages/authority-levels/AuthorityLevelCreatePage';
import HcpGroupsPage from './pages/hcp-groups/HcpGroupsPage';
import ErrorPage from './pages/ErrorPage';

const App: React.FC = () => {
  React.useEffect(() => {
    initServices();
  }, []);

  return (
    <ShowOnRootProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<AuthWrapperContainer isAuthScreen={false} />}>
          <Route index element={<RootPage />} />
        </Route>
        <Route path="/login" element={<AuthWrapperContainer isAuthScreen={false} />}>
          <Route index element={<LoginPage />} />
        </Route>

        {/* Protected routes */}
        <Route path="/*" element={<AuthWrapperContainer isAuthScreen={true} />}>
          <Route path="dashboard" element={<DashboardPage />} />

          <Route path="alerts" element={<AlertsPage />} />
          <Route path="alerts/:id" element={<AlertDetailPage />} />

          <Route path="residents" element={<ResidentsPage />} />
          <Route path="residents/create" element={<ResidentCreatePage />} />
          <Route path="residents/:id" element={<ResidentDetailPage />} />
          <Route path="residents/:id/edit" element={<ResidentEditPage />} />

          <Route path="healthcare-providers" element={<HealthcareProvidersPage />} />
          <Route path="healthcare-providers/create" element={<HealthcareProviderCreatePage />} />
          <Route path="healthcare-providers/:id/edit" element={<HealthcareProviderEditPage />} />

          <Route path="configuration" element={<ConfigurationPage />} />

          <Route path="authority-levels" element={<AuthorityLevelsPage />} />
          <Route path="authority-levels/create" element={<AuthorityLevelCreatePage />} />
          <Route path="authority-levels/:id" element={<AuthorityLevelDetailPage />} />
          <Route path="authority-levels/:id/edit" element={<AuthorityLevelEditPage />} />

          <Route path="hcp-groups" element={<HcpGroupsPage />} />

          {/* Error routes */}
          <Route path="404" element={<ErrorPage statusCode={404} />} />
          <Route path="500" element={<ErrorPage statusCode={500} />} />
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Route>
      </Routes>
      <ConfirmationContainer />
    </ShowOnRootProvider>
  );
};

export default observer(App);
